const API_URL = process.env.REACT_APP_API_URL || "https://uacapi.vikramsuwasiya.com/api";
export const TOKEN_KEY = "forma-token";
export async function api(path, options = {}) {
  const token = sessionStorage.getItem(TOKEN_KEY);
  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      ...(options.body instanceof FormData
        ? {}
        : { "Content-Type": "application/json" }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  }).catch(() => {
    throw new Error(
      "Unable to reach the server. Check that the backend is running.",
    );
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (response.status === 401 && !path.startsWith("/auth/"))
      window.dispatchEvent(new Event("forma-session-expired"));
    throw new Error(data.message || "Something went wrong. Please try again.");
  }
  return data;
}
export const creativeApi = {
  list: () => api("/creatives"),
  update: (id, changes) =>
    api(`/creatives/${id}`, { method: "PATCH", body: JSON.stringify(changes) }),
  upload: (id, form, approved = false) =>
    api(`/creatives/${id}/upload${approved ? "?approved=true" : ""}`, {
      method: "POST",
      body: form,
    }),
};
